import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { VopRequestService, VopRequest, ListVopRequestParams } from 'src/app/core/vop-request.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ERROR_VOP_REQUEST_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-vop-request-data',
  templateUrl: './vop-request-data.component.html',
  styleUrls: ['./vop-request-data.component.scss'],
})
export class VopRequestDataComponent {
  @ViewChild('vop_request_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  vop_requests?: VopRequest[];
  cursor: string | null = null;
  total?: number;
  filters?: ListVopRequestParams;

  constructor(private vop_request_service: VopRequestService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.vop_requests = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listVopRequest();
  }

  onRefresh(): void {
    this.vop_requests = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listVopRequest();
  }

  onFilter(filters?: ListVopRequestParams): void {
    this.vop_requests = [];
    this.cursor = null;
    this.filters = filters;
    this.total = undefined;
    this.listVopRequest(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listVopRequest(this.filters, true);
  }

  listVopRequest(filters?: ListVopRequestParams, is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_vop_request_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.vop_request_service.listVopRequest(list_vop_request_params).subscribe({
      next: response => {
        const vop_requests = response.data.data;
        this.vop_requests = (this.vop_requests ? this.vop_requests : []).concat(vop_requests);
        this.cursor = response.data.cursor;
        if (list_vop_request_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_VOP_REQUEST_NOT_FOUND) {
          this.vop_requests = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
